import { render, staticRenderFns } from "./EntitiesList.vue?vue&type=template&id=3038e6fd"
import script from "./EntitiesList.vue?vue&type=script&lang=js"
export * from "./EntitiesList.vue?vue&type=script&lang=js"
import style0 from "./EntitiesList.vue?vue&type=style&index=0&id=3038e6fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports